import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import axios from 'axios';
import { getStorageValues } from '../CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';


function StatusGridDropdown({
    onChangeDropdown,
    modelName,
    required,
    selectedValue,
    showLabel,
    autoFocus,
    onBlur,
    openMenuOnFocus,
    openMenuOnClick
}) {
    const [selectedStatusOption, setSelectedStatusOption] = useState(null);
    const [getStatusOptions, setStatusOptions] = useState([]);
    
    function handleChange(e, actionMeta) {
        setSelectedStatusOption(e);
        onChangeDropdown(e, actionMeta);
    };

    const fetchStatus = async () => {
        try {
            let statusDetails = {
                UserId: getStorageValues('userId')
            };
            const response = await axios.get(getApiBaseUrl() + "/statuslist", { params: statusDetails });
            if (response.status === 200) {
                setStatusDropdownData(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function setStatusDropdownData(cct) {
        let allModuleOpt = [];
        allModuleOpt = cct.map(p => ({ value: p.StatusId, label: p.StatusName, name: 'Status', description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setStatusOptions(allModuleOpt);
        const selected = allModuleOpt.find((x) => String(x.value) === String(selectedValue));
        setSelectedStatusOption(selected || null);
    }

    useEffect(() => {
        fetchStatus();
    }, []);
    return (
        <>
            <Select
                className="GridDropdown"
                name={modelName}
                value={selectedStatusOption}
                isClearable
                options={getStatusOptions || [] }
                onChange={handleChange}
                onBlur={onBlur}
                autoFocus={autoFocus}
                openMenuOnFocus={openMenuOnFocus}
                openMenuOnClick={openMenuOnClick}
                menuPlacement="auto"
                menuPosition="fixed"
                menuPortalTarget={document.body}
                styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: 32,
                      height: 32,
                      fontSize: '0.85rem',
                      borderColor: state.isFocused ? '#2684FF' : '#ccc',
                      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
                      '&:hover': {
                        borderColor: '#2684FF',
                      },
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: 32,
                      padding: '0 8px',
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: 32,
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 10000,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
        </>
                
    )
}

export default StatusGridDropdown